import { useState } from "react"
import { Button, Modal } from 'react-bootstrap'
import toast from "react-hot-toast"
import { X } from "lucide-react"

import LoadingTextSwap from "../../LoadingTextSwap"
import { useLeaveClubMutation } from '../../../app/userApiSlice'
import { useModal } from "../../../context/ModalContext"
import TrBtn from "./TrBtn"

interface LeaveClubButtonProps {
  uid: string,
  clubId: string
}

const LeaveClubButton = ({ uid, clubId }: LeaveClubButtonProps) => {
  const { openModal } = useModal()
  const [leaveClub, { isLoading }] = useLeaveClubMutation()

  const [show, setShow] = useState(false)

  const handleShow = () => setShow(true)
  const handleClose = () => {
    setShow(false)
  }

  const handleConfirm = async () => {
    try {
      await leaveClub({ uid, clubId }).unwrap()
      openModal({
        title: (
          <span>Request sent</span>
        ),
        body: (
          <span>The admin team have received your request and will process it shortly.</span>
        )
      })
      handleClose()

    } catch (error) {
      console.log(error)
      toast.error("An error occurred")
    }
  }

  return (
    <>
      <TrBtn
        text="Leave club"
        action={handleShow}
      >
        <X size={15} />
      </TrBtn>

      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header className="border-0 p-0 mb-2">
          <Modal.Title className="fs-5 fw-bold">Leave club?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0 text-muted fs-7 mb-3">A request will be sent to the admin team.</Modal.Body>
        <Modal.Footer className="p-0 border-0">
          <Button disabled={isLoading} className="shadow-sm m-0 fs-7 rounded-3" variant="dark" onClick={handleConfirm}>
            <LoadingTextSwap isLoading={isLoading}>
              Confirm
            </LoadingTextSwap>
          </Button>
          <Button className="shadow-sm rounded-3 border-1 m-0 ms-2 border-light fs-7" variant="" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default LeaveClubButton